/** @jsx jsx */
import { jsx } from 'theme-ui'

export const Pre = ({ children }) => <div>{children}</div>
